if (!window.Eurus.loadedScript.includes('lp-frieren.js')) {
    window.Eurus.loadedScript.push('lp-frieren.js');
}
const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
    window.Eurus.loadedScript.push(name);
    (events => {
        const loadScript = () => {
            events.forEach(type => window.removeEventListener(type, loadScript));
            clearTimeout(autoloadScript);
            const initScript = () => {
                const script = document.createElement('script');
                script.setAttribute('src', src);
                script.setAttribute('defer', '');
                script.onload = () => {
                    document.dispatchEvent(new CustomEvent(name + ' loaded'));
                    onload();
                };
                document.head.appendChild(script);
            };
            if (requestVisualChange) {
                if (window.requestIdleCallback) {
                    requestIdleCallback(initScript);
                }
                else {
                    requestAnimationFrame(initScript);
                }
            }
            else {
                initScript();
            }
        };
        let autoloadScript;
        const wait = window.innerWidth > 767 ? 2000 : 5000;
        events.forEach(type => window.addEventListener(type, loadScript, { once: true, passive: true }));
        autoloadScript = setTimeout(() => {
            loadScript();
        }, wait);
    })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
};
// alpine func
requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        Alpine.store('xSplide', {
            load(el, configs) {
                const initSlider = () => {
                    const id = el.getAttribute("id");
                    if (configs.classes != undefined) {
                        if (!configs.classes.arrow)
                            configs.classes.arrow = "arrow w-8 h-8 p-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
                        if (!configs.classes.next)
                            configs.classes.next = "right-0";
                        if (!configs.classes.prev)
                            configs.classes.prev = "-rotate-180";
                    }
                    let splide = new Splide("#" + id, configs);
                    if (configs.thumbs) {
                        let thumbsRoot = document.getElementById(configs.thumbs);
                        let thumbs = thumbsRoot.getElementsByClassName('x-thumbnail');
                        let current;
                        let _this = this;
                        for (let i = 0; i < thumbs.length; i++) {
                            if (thumbs[i] == current) {
                                thumbs[i].classList.remove('opacity-30');
                            }
                            else {
                                thumbs[i].classList.add('opacity-30');
                            }
                            thumbs[i].addEventListener('click', function () {
                                _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                splide.go(i);
                            });
                        }
                        splide.on('refresh', function () {
                            for (let i = 0; i < thumbs.length; i++) {
                                thumbs[i].removeEventListener('click', function () {
                                    _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                    splide.go(i);
                                });
                            }
                            let thumbsRoot = document.getElementById(configs.thumbs);
                            let thumbsNew = thumbsRoot.getElementsByClassName('x-thumbnail');
                            for (let i = 0; i < thumbsNew.length; i++) {
                                if (i == 0) {
                                    thumbsNew[i].classList.remove('opacity-30');
                                }
                                else {
                                    thumbsNew[i].classList.add('opacity-30');
                                }
                                thumbsNew[i].addEventListener('click', function () {
                                    _this.moveThumbnail(i, thumbsNew[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                                    splide.go(i);
                                });
                            }
                        });
                        splide.on('mounted move', function () {
                            let thumbnail = thumbs[splide.index];
                            if (thumbnail) {
                                if (current) {
                                    current.classList.add('opacity-30');
                                }
                                thumbnail.classList.remove('opacity-30');
                                current = thumbnail;
                                _this.moveThumbnail(splide.index, thumbnail, thumbsRoot, configs.thumbs_direction, configs.direction);
                            }
                        });
                    }
                    if (configs.hotspot) {
                        let hotspotRoot = document.getElementById(configs.hotspot);
                        let hotspots = hotspotRoot.getElementsByClassName('x-hotspot');
                        let current;
                        if (configs.disableHoverOnTouch && (('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints)) {
                            for (let i = 0; i < hotspots.length; i++) {
                                hotspots[i].addEventListener('click', function () {
                                    splide.go(i);
                                });
                            }
                        }
                        else {
                            for (let i = 0; i < hotspots.length; i++) {
                                hotspots[i].addEventListener('mouseover', function () {
                                    splide.go(i);
                                });
                                hotspots[i].addEventListener('focus', function () {
                                    splide.go(i);
                                });
                            }
                        }
                        splide.on('mounted move', function () {
                            let hotspot = hotspots[splide.index];
                            if (hotspot) {
                                if (current) {
                                    current.classList.remove('active-hotspot');
                                }
                                hotspot.classList.add('active-hotspot');
                                current = hotspot;
                            }
                        });
                    }
                    if (configs.cardHover) {
                        let cardImage = document.getElementById(configs.cardHover);
                        if (window.innerWidth > 1024) {
                            cardImage.addEventListener('mousemove', function (e) {
                                let left = e.offsetX;
                                let width = cardImage.getBoundingClientRect().width;
                                let spacing = left / width;
                                let index = Math.floor(spacing * configs.maxSlide);
                                splide.go(index);
                            });
                            cardImage.addEventListener('mouseleave', function (e) {
                                splide.go(0);
                            });
                        }
                    }
                    if (configs.progressBar) {
                        var bar = splide.root.querySelector('.splide-progress-bar');
                        splide.on('mounted move', function () {
                            var end = configs.progressBar;
                            if (configs.progressBarHeader) {
                                end = splide.Components.Slides.getLength();
                            }
                            var rate = 100 * (splide.index / end);
                            if (bar) {
                                var widthBar = window.getComputedStyle(bar).getPropertyValue('width').replace("px", '');
                                var widthProgressBar = window.getComputedStyle(bar.closest('.splide-progress')).getPropertyValue('width').replace("px", '');
                                var percentBar = 100 * (Number(widthBar) / Number(widthProgressBar));
                                var rateBar = rate + percentBar;
                                var maxRate = 100 - percentBar;
                                if (rateBar > 100) {
                                    rate = maxRate;
                                }
                                if (document.querySelector('body').classList.contains('rtl')) {
                                    bar.style.marginRight = rate + '%';
                                }
                                else {
                                    bar.style.marginLeft = rate + '%';
                                }
                            }
                        });
                    }
                    if (el.classList.contains('card-product-img')) {
                        splide.on('resized', function () {
                            var height = splide.root.querySelector('.splide__track').offsetHeight;
                            splide.Components.Slides.get().forEach((item) => {
                                item.slide.style.height = height + "px";
                            });
                        });
                    }
                    if (configs.events) {
                        configs.events.forEach((e) => {
                            splide.on(e.event, e.callback);
                        });
                    }
                    el.splide = splide;
                    splide.mount();
                    if (configs.playOnHover) {
                        splide.Components.Autoplay.pause();
                        el.onmouseover = function () {
                            splide.Components.Autoplay.play();
                        };
                        el.onmouseout = function () {
                            splide.Components.Autoplay.pause();
                        };
                    }
                };
                if (!window.Eurus.loadedScript.includes('slider')) {
                    deferScriptLoad('slider', window.Eurus.sliderScript, initSlider, true);
                }
                else if (window.Splide) {
                    initSlider();
                }
                else {
                    document.addEventListener('slider loaded', () => {
                        initSlider();
                    });
                }
            },
            moveThumbnail(index, thumbnail, thumbsRoot, direction) {
                if (thumbnail) {
                    if (direction == 'vertical') {
                        setTimeout(() => {
                            thumbsRoot.scrollTop = (index + 1) * thumbnail.offsetHeight - thumbsRoot.offsetHeight * 0.5 + thumbnail.offsetHeight * 0.5 + index * 12;
                        }, 50);
                    }
                    else {
                        thumbsRoot.scrollLeft = (index - 2) * thumbnail.offsetWidth;
                    }
                }
            }
        });
        // global vars
        Alpine.store('global', {
            navAccent: 'top',
            headerHeight: 90
        }),
            Alpine.data('frierenKv', () => ({
                kvBind: {
                    ['x-intersect:enter']: "$store.global.navAccent = 'top'"
                }
            })),
            Alpine.data('loadingSplash', () => ({
                splashHide: {
                    [':class']: "loaded && 'opacity-0 pointer-events-none'",
                    [':aria-hidden']: "loaded ? 'true' : 'false'"
                },
                loadingText: {
                    ['x-init']: "$watch('loaded', value => { setTimeout(() => { $el.classList.add('[animation-play-state:paused]'); }, 800); })",
                },
            })),
            Alpine.data('frierenSection', () => ({
                sectionKeyboard: {
                    ['x-data']: "{ active : false, layout : 'jis' }",
                    ['x-intersect:enter']: `$store.global.navAccent = 'keyboard'`,
                    ['x-intersect:enter.33%.once']: "active = true",
                },
                layoutSelect: {
                    ['@change']: "layout = $event.target.value"
                },
                sectionNone: {
                    ['x-data']: "{ active : false }",
                    ['x-intersect:enter.33%.once']: "$store.global.navAccent = ''; active = true",
                },
                heading: {
                    [':class']: "active ? 'text-white bg-size-[100%_100%]' : 'text-teal bg-size-[0%_100%]'",
                },
                ansi: {
                    [':class']: "layout == 'ansi' || 'opacity-0'",
                    [':aria-hidden']: "layout == 'ansi' ? 'false' : 'true'"
                },
                jis: {
                    [':class']: "layout == 'jis' || 'opacity-0'",
                    [':aria-hidden']: "layout == 'jis' ? 'false' : 'true'"
                }
            })),
            Alpine.data('frierenHeader', () => ({
                headerBind: {
                    ['x-init']: "$store.global.headerHeight = $el.getBoundingClientRect().height + 10",
                    ['@resize.window.throttle']: "$store.global.headerHeight = $el.getBoundingClientRect().height + 10",
                },
                navTop: {
                    ['@click.prevent']: "scrollTo({ top: 0 , behavior: 'auto' })",
                    [':class']: "$store.global.navAccent == 'top' ? 'text-gold' : 'text-teal'"
                },
                navTopMobile: {
                    ['@click.prevent']: "scrollTo({ top: 0 , behavior: 'auto' }); $store.lpMobileNav.close();",
                    [':class']: "$store.lpMobileNav.show || 'opacity-0 -translate-x-1/3'",
                    [':tabindex']: "$store.lpMobileNav.show ? '0' : '-1'",
                },
                navKeyboard: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(document.querySelector('#keyboard').offsetTop - $store.global.headerHeight) , behavior: 'auto' });",
                    [':class']: "$store.global.navAccent == 'keyboard' ? 'text-gold' : 'text-teal'"
                },
                navKeyboardMobile: {
                    ['@click.prevent']: "scrollTo({ top: Math.floor(document.querySelector('#keyboard').offsetTop - $store.global.headerHeight) , behavior: 'auto' }); $store.lpMobileNav.close();",
                    [':class']: "$store.lpMobileNav.show || 'opacity-0 -translate-x-1/3'",
                    [':tabindex']: "$store.lpMobileNav.show ? '0' : '-1'",
                },
                navDetails: {
                    ['x-effect']: "$el.toggleAttribute('open', $store.lpMobileNav.show)"
                },
                navBtn: {
                    ['@click.prevent']: "$store.lpMobileNav.toggle()",
                    [':aria-expanded']: "$store.lpMobileNav.show ? 'true' : 'false'"
                },
                mobileNav: {
                    ['x-show']: "$store.lpMobileNav.show",
                    ['x-transition.opacity']: ""
                },
                navHamburger: {
                    ['x-show']: "!$store.lpMobileNav.show",
                },
                navClose: {
                    ['x-show']: "$store.lpMobileNav.show"
                },
            })),
            // toggle data
            Alpine.data('lpToggle', () => ({
                open: false,
                toggleDetails: {
                    ['x-effect']: "$el.toggleAttribute('open', open)"
                },
                toggleBtn: {
                    ['@click.prevent']: "open = ! open; !open && $el.parentElement.getBoundingClientRect().y - $store.global.headerHeight < 0 && scrollTo({ top: Math.floor($el.parentElement.getBoundingClientRect().y + window.scrollY - $store.global.headerHeight) , behavior: 'instant' })",
                    [':aria-expanded']: "open ? 'true' : 'false'",
                    [':class']: "open && 'sticky top-20 md:top-22 z-2 shadow-lg'"
                },
                btnLabel: {
                    ['x-init']: "$watch('open', value => $el.textContent = open ? 'Close details' : 'Show more')"
                },
                btnGraphic: {
                    [':class']: "open ? 'rotate-45' : '-rotate-45'"
                },
                toggleContent: {
                    ['x-show']: "open",
                    ['x-transition:enter.opacity.duration.500ms']: ''
                },
            })),
            // mobile nav
            Alpine.store('lpMobileNav', {
                show: false,
                toggle() {
                    this.show = !this.show;
                },
                close() {
                    this.show = false;
                }
            });
    });
});
